import { authorizedFetch, ErrorResponse } from './api-client';
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

export interface FollowUp {
  id: string;
  engagement_id: string | null;
  patient_id: string;
  clinic_id: string;
  follow_up_type: string;
  follow_up_status: string;
  assigned_to: string | null;
  notes: string | null;
  completed_at: string | null;
  created_at: string | null;
  // Campos extras vindos do join (populados pelo frontend se necessário)
  patient_name?: string;
  patient_phone?: string;
}

export async function fetchFollowUps(
  clinicId: string,
  followUpStatus?: string,
  followUpType?: string,
  page = 1,
  pageSize = 20,
): Promise<FollowUp[]> {
  const params = new URLSearchParams({
    clinic_id: clinicId,
    page: page.toString(),
    page_size: pageSize.toString(),
  });
  if (followUpStatus) params.append('follow_up_status', followUpStatus);
  if (followUpType) params.append('follow_up_type', followUpType);

  const response = await authorizedFetch(
    `${API_BASE_URL}/api/v1/follow-up/?${params.toString()}`
  );

  if (!response.ok) {
    throw new Error('Erro ao buscar follow-ups');
  }

  const data = await response.json();
  return data.items ?? data;
}

export async function fetchFollowUpPendingCount(clinicId: string): Promise<number> {
  const response = await authorizedFetch(
    `${API_BASE_URL}/api/v1/follow-up/pending/count?clinic_id=${clinicId}`
  );

  if (!response.ok) return 0;

  const data = await response.json();
  return data.count ?? 0;
}

export async function updateFollowUpStatus(
  id: string,
  followUpStatus: string,
): Promise<void> {
  const response = await authorizedFetch(
    `${API_BASE_URL}/api/v1/follow-up/${id}/status`,
    {
      method: 'PATCH',
      body: JSON.stringify({ follow_up_status: followUpStatus }),
    }
  );

  if (!response.ok) {
    const error: ErrorResponse = await response.json();
    throw new Error(error.detail || 'Erro ao atualizar status');
  }
}

export async function updateFollowUpNotes(
  id: string,
  notes: string,
): Promise<void> {
  const response = await authorizedFetch(
    `${API_BASE_URL}/api/v1/follow-up/${id}/notes`,
    {
      method: 'PATCH',
      body: JSON.stringify({ notes }),
    }
  );

  if (!response.ok) {
    const error: ErrorResponse = await response.json();
    throw new Error(error.detail || 'Erro ao atualizar observações');
  }
}
